<template>
  <div class="loading-wrap">
    <a-spin />
  </div>
</template>
<script>
export default {
  name: 'Loading'
}
</script>
<style lang="less" scoped>
.loading-wrap {
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
